
import api from 'appRedux/api';

export const fetchCountries = async (whiteLabelName) => {
    try {
        const url = `routes/whitelabel/${whiteLabelName}/countries`;
        const response = await api.get(url);
        return response.data; 
    } catch (error) {
        console.error('Error fetching countries:', error);
        return { data: [] }; 
    }
};

export const fetchStates = async (countryId) => {
    try {
        const url = `/states/${countryId}/list`;
        const response = await api.get(url);
        return response.data; 
    } catch (error) {
        console.error('Error fetching states:', error);
        return { data: [] }; 
    }
};